var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_4_4",
    "data-name": "Componente 4 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2007",
    "data-name": "Grupo 2007",
    transform: "translate(-146 -687)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(146 687)",
    fill: "#009ebe"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_357",
    "data-name": "Caminho 357",
    d: "M30.188,8.427,16.626.3a2.247,2.247,0,0,0-2.252,0L.812,8.427a1.465,1.465,0,0,0-.45,2.267,2.186,2.186,0,0,0,2.7.378l.812-.486V24.375A1.8,1.8,0,0,0,5.812,26H25.188a1.8,1.8,0,0,0,1.938-1.625V10.586a3.591,3.591,0,0,0,1.936.789,2.07,2.07,0,0,0,1.578-.681A1.465,1.465,0,0,0,30.188,8.427ZM23.25,22.75H19.375V17.875c0-1.795-1.735-3.25-3.875-3.25s-3.875,1.455-3.875,3.25V22.75H7.75V8.265L15.5,3.622l7.75,4.643Z",
    transform: "translate(11.5 12.935)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.8cd2d5da41c5264b1c8830b6a0799677.svg";
export { ForwardRef as ReactComponent };